// eslint-disable-next-line import/default
import Pilot from 'system/libs/Pilot';

const AUTOTESTING_STORAGE_KEY = 'x-mcs-autotesting';
const AUTOTESTING_STORAGE_VALUE = '1';

// Не все браузеры имеют конструктор URL и поддерживают URLSearchParams,
// поэтому забираем query-параметры из Pilot.URL, чтобы не подключать polyfill.
// https://developer.mozilla.org/en-US/docs/Web/API/URL/searchParams
const searchParams = new Pilot.URL(window.location.href).query || {};
let isAutoTesting =
    searchParams.utm_source === 'Autotest' &&
    searchParams.utm_medium === 'test';

if (isAutoTesting) {
    try {
        // Query-параметры могут поетряться при роутинге и редиректах,
        // поэтому запомним статус автотестирования.
        sessionStorage.setItem(
            AUTOTESTING_STORAGE_KEY,
            AUTOTESTING_STORAGE_VALUE,
        );
    } catch (reason) {
        // nothing to do
    }
} else {
    try {
        if (
            sessionStorage.getItem(AUTOTESTING_STORAGE_KEY) ===
            AUTOTESTING_STORAGE_VALUE
        ) {
            isAutoTesting = true;
        }
    } catch (reason) {
        // nothing to do
    }
}

let marketplaceBucket = searchParams.marketplace_bucket;

const MARKETPLACE_BUCKET_KEY = 'x-mcs-marketplace-bucket';

if (marketplaceBucket) {
    try {
        // Query-параметры могут поетряться при роутинге и редиректах,
        // поэтому запомним статус автотестирования.
        sessionStorage.setItem(MARKETPLACE_BUCKET_KEY, marketplaceBucket);
    } catch (reason) {
        // nothing to do
    }
} else {
    try {
        const value = sessionStorage.getItem(MARKETPLACE_BUCKET_KEY);
        if (value) {
            marketplaceBucket = value;
        }
    } catch (reason) {
        // nothing to do
    }
}

export const TestParams = {
    isAutoTesting,
    marketplaceBucket,
};
